import { api } from '../../';
import { SetupData } from './types';

export const setupApi = api.enhanceEndpoints({ addTagTypes: ['Setup'] }).injectEndpoints({
  endpoints: build => ({
    getSetupList: build.query<SetupData, any>({
      query: ({ queryString }) => ({
        url: `v1/promotions/prize-config?${queryString}`,
        method: 'GET',
      }),
    }),
    createSetup: build.mutation<any, any>({
      query: body => ({
        url: `v1/promotions/prize-config`,
        method: 'POST',
        body,
      }),
    }),
    updateSetup: build.mutation<any, any>({
      query: body => ({
        url: `v1/promotions/prize-config/${body.id}`,
        method: 'PATCH',
        body: body.data,
      }),
    }),
    publishSetup: build.mutation<any, number>({
      query: id => ({
        url: `v1/promotions/prize-config/${id}/publish`,
        method: 'POST',
      }),
    }),
    unpublishSetup: build.mutation<any, number>({
      query: id => ({
        url: `v1/promotions/prize-config/${id}/unpublish`,
        method: 'POST',
      }),
    }),
  }),
});

export const { useLazyGetSetupListQuery, useCreateSetupMutation, useUpdateSetupMutation, usePublishSetupMutation, useUnpublishSetupMutation } = setupApi;